// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/agent_server.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ListRequestSchema } from "./common_pb.js";
import { file_agentplatform_httpv2_common } from "./common_pb.js";
import type { Agent, AgentAdvancedConfig, AgentChannelConfig, AgentModelConfig, AgentPluginConfig } from "../v1/agent_pb.js";
import { file_agentplatform_v1_agent } from "../v1/agent_pb.js";
import type { ChannelAccount } from "../v1/channel_pb.js";
import { file_agentplatform_v1_channel } from "../v1/channel_pb.js";
import type { Instance, InstanceSubresource } from "../v1/instance_pb.js";
import { file_agentplatform_v1_instance } from "../v1/instance_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/agent_server.proto.
 */
export const file_agentplatform_httpv2_agent_server: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_httpv2_common, file_agentplatform_v1_agent, file_agentplatform_v1_channel, file_agentplatform_v1_instance, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations, file_google_protobuf_empty]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateAgentRequest
 */
export type CreateAgentRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateAgentRequest"> & {
  /**
   * 智能体名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 智能体描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * 智能体模型配置
   * @gotags: json:"model_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentModelConfig model_config = 7 [json_name = "model_config"];
   */
  modelConfig?: AgentModelConfig | undefined;

  /**
   * 智能体渠道配置
   * @gotags: json:"channel_configs,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.AgentChannelConfig channel_configs = 8 [json_name = "channel_configs"];
   */
  channelConfigs: AgentChannelConfig[];

  /**
   * 智能体插件配置
   * @gotags: json:"plugin_configs,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.AgentPluginConfig plugin_configs = 9 [json_name = "plugin_configs"];
   */
  pluginConfigs: AgentPluginConfig[];

  /**
   * 智能体高级配置
   * @gotags: json:"advanced_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentAdvancedConfig advanced_config = 10 [json_name = "advanced_config"];
   */
  advancedConfig?: AgentAdvancedConfig | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateAgentRequest.
 * Use `create(CreateAgentRequestSchema)` to create a new message.
 */
export const CreateAgentRequestSchema: GenMessage<CreateAgentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateAgentResponse
 */
export type CreateAgentResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateAgentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Agent data = 4;
   */
  data?: Agent | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateAgentResponse.
 * Use `create(CreateAgentResponseSchema)` to create a new message.
 */
export const CreateAgentResponseSchema: GenMessage<CreateAgentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetAgentRequest
 */
export type GetAgentRequest = Message<"infinigence.infini.agentplatform.httpv2.GetAgentRequest"> & {
  /**
   * 智能体 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetAgentRequest.
 * Use `create(GetAgentRequestSchema)` to create a new message.
 */
export const GetAgentRequestSchema: GenMessage<GetAgentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetAgentResponse
 */
export type GetAgentResponse = Message<"infinigence.infini.agentplatform.httpv2.GetAgentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Agent data = 4;
   */
  data?: Agent | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetAgentResponse.
 * Use `create(GetAgentResponseSchema)` to create a new message.
 */
export const GetAgentResponseSchema: GenMessage<GetAgentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateAgentRequest
 */
export type UpdateAgentRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateAgentRequest"> & {
  /**
   * 智能体 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 智能体名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 智能体描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 智能体模型配置
   * @gotags: json:"model_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentModelConfig model_config = 7 [json_name = "model_config"];
   */
  modelConfig?: AgentModelConfig | undefined;

  /**
   * 智能体渠道配置
   * @gotags: json:"channel_configs,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.AgentChannelConfig channel_configs = 8 [json_name = "channel_configs"];
   */
  channelConfigs: AgentChannelConfig[];

  /**
   * 智能体插件配置
   * @gotags: json:"plugin_configs,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.AgentPluginConfig plugin_configs = 9 [json_name = "plugin_configs"];
   */
  pluginConfigs: AgentPluginConfig[];

  /**
   * 智能体高级配置
   * @gotags: json:"advanced_config,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.AgentAdvancedConfig advanced_config = 10 [json_name = "advanced_config"];
   */
  advancedConfig?: AgentAdvancedConfig | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateAgentRequest.
 * Use `create(UpdateAgentRequestSchema)` to create a new message.
 */
export const UpdateAgentRequestSchema: GenMessage<UpdateAgentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateAgentResponse
 */
export type UpdateAgentResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateAgentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Agent data = 4;
   */
  data?: Agent | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateAgentResponse.
 * Use `create(UpdateAgentResponseSchema)` to create a new message.
 */
export const UpdateAgentResponseSchema: GenMessage<UpdateAgentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteAgentRequest
 */
export type DeleteAgentRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteAgentRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteAgentRequest.
 * Use `create(DeleteAgentRequestSchema)` to create a new message.
 */
export const DeleteAgentRequestSchema: GenMessage<DeleteAgentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 6);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteAgentResponse
 */
export type DeleteAgentResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteAgentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteAgentResponse.
 * Use `create(DeleteAgentResponseSchema)` to create a new message.
 */
export const DeleteAgentResponseSchema: GenMessage<DeleteAgentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListAgentsResponse
 */
export type ListAgentsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListAgentsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListAgentsData data = 4;
   */
  data?: ListAgentsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListAgentsResponse.
 * Use `create(ListAgentsResponseSchema)` to create a new message.
 */
export const ListAgentsResponseSchema: GenMessage<ListAgentsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 8);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListAgentsData
 */
export type ListAgentsData = Message<"infinigence.infini.agentplatform.httpv2.ListAgentsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Agent items = 1;
   */
  items: Agent[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListAgentsData.
 * Use `create(ListAgentsDataSchema)` to create a new message.
 */
export const ListAgentsDataSchema: GenMessage<ListAgentsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RestartAgentRequest
 */
export type RestartAgentRequest = Message<"infinigence.infini.agentplatform.httpv2.RestartAgentRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RestartAgentRequest.
 * Use `create(RestartAgentRequestSchema)` to create a new message.
 */
export const RestartAgentRequestSchema: GenMessage<RestartAgentRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.RestartAgentResponse
 */
export type RestartAgentResponse = Message<"infinigence.infini.agentplatform.httpv2.RestartAgentResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.RestartAgentResponse.
 * Use `create(RestartAgentResponseSchema)` to create a new message.
 */
export const RestartAgentResponseSchema: GenMessage<RestartAgentResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInternalToolkitsResponse
 */
export type ListInternalToolkitsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListInternalToolkitsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListInternalToolkitsData data = 4;
   */
  data?: ListInternalToolkitsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInternalToolkitsResponse.
 * Use `create(ListInternalToolkitsResponseSchema)` to create a new message.
 */
export const ListInternalToolkitsResponseSchema: GenMessage<ListInternalToolkitsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInternalToolkitsData
 */
export type ListInternalToolkitsData = Message<"infinigence.infini.agentplatform.httpv2.ListInternalToolkitsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.InternalToolkit items = 1;
   */
  items: InternalToolkit[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInternalToolkitsData.
 * Use `create(ListInternalToolkitsDataSchema)` to create a new message.
 */
export const ListInternalToolkitsDataSchema: GenMessage<ListInternalToolkitsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.InternalToolkit
 */
export type InternalToolkit = Message<"infinigence.infini.agentplatform.httpv2.InternalToolkit"> & {
  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.InternalToolkit.
 * Use `create(InternalToolkitSchema)` to create a new message.
 */
export const InternalToolkitSchema: GenMessage<InternalToolkit> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateInstanceRequest
 */
export type CreateInstanceRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateInstanceRequest"> & {
  /**
   * 归属智能体 ID（必填）
   * @gotags: json:"agent_id"
   *
   * @generated from field: string agent_id = 1 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 实例名称
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 实例参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 4;
   */
  params: { [key: string]: string };

  /**
   * 子资源列表
   * @gotags: json:"subresources,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.InstanceSubresource subresources = 5;
   */
  subresources: InstanceSubresource[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateInstanceRequest.
 * Use `create(CreateInstanceRequestSchema)` to create a new message.
 */
export const CreateInstanceRequestSchema: GenMessage<CreateInstanceRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateInstanceResponse
 */
export type CreateInstanceResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateInstanceResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Instance data = 4;
   */
  data?: Instance | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateInstanceResponse.
 * Use `create(CreateInstanceResponseSchema)` to create a new message.
 */
export const CreateInstanceResponseSchema: GenMessage<CreateInstanceResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 16);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInstanceRequest
 */
export type GetInstanceRequest = Message<"infinigence.infini.agentplatform.httpv2.GetInstanceRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInstanceRequest.
 * Use `create(GetInstanceRequestSchema)` to create a new message.
 */
export const GetInstanceRequestSchema: GenMessage<GetInstanceRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetInstanceResponse
 */
export type GetInstanceResponse = Message<"infinigence.infini.agentplatform.httpv2.GetInstanceResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Instance data = 4;
   */
  data?: Instance | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetInstanceResponse.
 * Use `create(GetInstanceResponseSchema)` to create a new message.
 */
export const GetInstanceResponseSchema: GenMessage<GetInstanceResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateInstanceRequest
 */
export type UpdateInstanceRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateInstanceRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 实例名称
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 实例描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * 实例参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: map<string, string> params = 4;
   */
  params: { [key: string]: string };
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateInstanceRequest.
 * Use `create(UpdateInstanceRequestSchema)` to create a new message.
 */
export const UpdateInstanceRequestSchema: GenMessage<UpdateInstanceRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 19);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateInstanceResponse
 */
export type UpdateInstanceResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateInstanceResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.Instance data = 4;
   */
  data?: Instance | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateInstanceResponse.
 * Use `create(UpdateInstanceResponseSchema)` to create a new message.
 */
export const UpdateInstanceResponseSchema: GenMessage<UpdateInstanceResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 20);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteInstanceRequest
 */
export type DeleteInstanceRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteInstanceRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteInstanceRequest.
 * Use `create(DeleteInstanceRequestSchema)` to create a new message.
 */
export const DeleteInstanceRequestSchema: GenMessage<DeleteInstanceRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 21);

/**
 * 删除幂等：成功 / 不存在都返回 HTTP 200，envelope code "200"，不带 data
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteInstanceResponse
 */
export type DeleteInstanceResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteInstanceResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteInstanceResponse.
 * Use `create(DeleteInstanceResponseSchema)` to create a new message.
 */
export const DeleteInstanceResponseSchema: GenMessage<DeleteInstanceResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 22);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInstancesResponse
 */
export type ListInstancesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListInstancesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListInstancesData data = 4;
   */
  data?: ListInstancesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInstancesResponse.
 * Use `create(ListInstancesResponseSchema)` to create a new message.
 */
export const ListInstancesResponseSchema: GenMessage<ListInstancesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 23);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInstancesData
 */
export type ListInstancesData = Message<"infinigence.infini.agentplatform.httpv2.ListInstancesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Instance items = 1;
   */
  items: Instance[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInstancesData.
 * Use `create(ListInstancesDataSchema)` to create a new message.
 */
export const ListInstancesDataSchema: GenMessage<ListInstancesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 24);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.StopInstanceRequest
 */
export type StopInstanceRequest = Message<"infinigence.infini.agentplatform.httpv2.StopInstanceRequest"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.StopInstanceRequest.
 * Use `create(StopInstanceRequestSchema)` to create a new message.
 */
export const StopInstanceRequestSchema: GenMessage<StopInstanceRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 25);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.StopInstanceResponse
 */
export type StopInstanceResponse = Message<"infinigence.infini.agentplatform.httpv2.StopInstanceResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.StopInstanceResponse.
 * Use `create(StopInstanceResponseSchema)` to create a new message.
 */
export const StopInstanceResponseSchema: GenMessage<StopInstanceResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 26);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsRequest
 */
export type ListInstanceChannelAccountsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsRequest"> & {
  /**
   * 实例 ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 分页页码（从 1 开始；0 / 缺省 = 1）
   * @gotags: json:"page,omitempty"
   *
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * 每页大小（最大 1000；0 / 缺省 = 20）
   * @gotags: json:"page_size,omitempty"
   *
   * @generated from field: int32 page_size = 3 [json_name = "page_size"];
   */
  pageSize: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsRequest.
 * Use `create(ListInstanceChannelAccountsRequestSchema)` to create a new message.
 */
export const ListInstanceChannelAccountsRequestSchema: GenMessage<ListInstanceChannelAccountsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 27);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsResponse
 */
export type ListInstanceChannelAccountsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsData data = 4;
   */
  data?: ListInstanceChannelAccountsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsResponse.
 * Use `create(ListInstanceChannelAccountsResponseSchema)` to create a new message.
 */
export const ListInstanceChannelAccountsResponseSchema: GenMessage<ListInstanceChannelAccountsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 28);

/**
 * List 字段量大，按 spec §3.3 例外条款允许直接复用资源 message。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsData
 */
export type ListInstanceChannelAccountsData = Message<"infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ChannelAccount items = 1;
   */
  items: ChannelAccount[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListInstanceChannelAccountsData.
 * Use `create(ListInstanceChannelAccountsDataSchema)` to create a new message.
 */
export const ListInstanceChannelAccountsDataSchema: GenMessage<ListInstanceChannelAccountsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_agent_server, 29);

/**
 * AgentHTTPV2Service
 * Agent + Instance 的 CRUD
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service
 */
export const AgentHTTPV2Service: GenService<{
  /**
   * ---- Agent ----
   * 创建智能体
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.CreateAgent
   */
  createAgent: {
    methodKind: "unary";
    input: typeof CreateAgentRequestSchema;
    output: typeof CreateAgentResponseSchema;
  },
  /**
   * 获取单个智能体
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.GetAgent
   */
  getAgent: {
    methodKind: "unary";
    input: typeof GetAgentRequestSchema;
    output: typeof GetAgentResponseSchema;
  },
  /**
   * 更新智能体
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.UpdateAgent
   */
  updateAgent: {
    methodKind: "unary";
    input: typeof UpdateAgentRequestSchema;
    output: typeof UpdateAgentResponseSchema;
  },
  /**
   * 删除智能体（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.DeleteAgent
   */
  deleteAgent: {
    methodKind: "unary";
    input: typeof DeleteAgentRequestSchema;
    output: typeof DeleteAgentResponseSchema;
  },
  /**
   * 列出智能体（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.ListAgents
   */
  listAgents: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListAgentsResponseSchema;
  },
  /**
   * 重启智能体（重新生成实例参数并停机重建）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.RestartAgent
   */
  restartAgent: {
    methodKind: "unary";
    input: typeof RestartAgentRequestSchema;
    output: typeof RestartAgentResponseSchema;
  },
  /**
   * 列出内置工具集
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.ListInternalToolkits
   */
  listInternalToolkits: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListInternalToolkitsResponseSchema;
  },
  /**
   * ---- Instance ----
   * 创建实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.CreateInstance
   */
  createInstance: {
    methodKind: "unary";
    input: typeof CreateInstanceRequestSchema;
    output: typeof CreateInstanceResponseSchema;
  },
  /**
   * 获取单个实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.GetInstance
   */
  getInstance: {
    methodKind: "unary";
    input: typeof GetInstanceRequestSchema;
    output: typeof GetInstanceResponseSchema;
  },
  /**
   * 更新实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.UpdateInstance
   */
  updateInstance: {
    methodKind: "unary";
    input: typeof UpdateInstanceRequestSchema;
    output: typeof UpdateInstanceResponseSchema;
  },
  /**
   * 删除实例（幂等：已删除返回 200）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.DeleteInstance
   */
  deleteInstance: {
    methodKind: "unary";
    input: typeof DeleteInstanceRequestSchema;
    output: typeof DeleteInstanceResponseSchema;
  },
  /**
   * 列出实例（分页 / 过滤）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.ListInstances
   */
  listInstances: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListInstancesResponseSchema;
  },
  /**
   * 停止实例
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.StopInstance
   */
  stopInstance: {
    methodKind: "unary";
    input: typeof StopInstanceRequestSchema;
    output: typeof StopInstanceResponseSchema;
  },
  /**
   * 列出实例关联的渠道账号
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.AgentHTTPV2Service.ListInstanceChannelAccounts
   */
  listInstanceChannelAccounts: {
    methodKind: "unary";
    input: typeof ListInstanceChannelAccountsRequestSchema;
    output: typeof ListInstanceChannelAccountsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_agent_server, 0);

